export const LOGIN = 'login/LOGIN';
export const LOGIN_SUCCESS = 'login/LOGIN_SUCCESS';
export const LOGIN_ERROR = 'login/LOGIN_ERROR';

export const REGISTER = 'login/REGISTER';
export const REGISTER_SUCCESS = 'login/REGISTER_SUCCESS';
export const REGISTER_ERROR = 'login/REGISTER_ERROR';

export const GET_USER = 'login/GET_USER';
export const GET_USER_SUCCESS = 'login/GET_USER_SUCCESS';
export const GET_USER_ERROR = 'login/GET_USER_ERROR';

export const UPDATE_USER = 'login/UPDATE_USER';
export const UPDATE_USER_SUCCESS = 'login/UPDATE_USER_SUCCESS';

export const CHANGE_PASSWORD = 'user/CHANGE_PASSWORD';
export const CHANGE_PASSWORD_ERROR = 'user/CHANGE_PASSWORD_ERROR';

export const UPDATE_USER_AVATAR = 'login/UPDATE_USER_AVATAR';
export const UPDATE_USER_AVATAR_SUCCESS = 'login/UPDATE_USER_AVATAR_SUCCESS';

export const SET_MODE = 'login/SET_MODE';
export const LOGOUT = 'login/LOGOUT';
